function normalizeTargetName(name) {
    if (!name) return name;
    const raw = String(name);
    if (raw.indexOf("_") !== -1) {
        return raw.toLowerCase();
    }
    return raw
        .replace(/([A-Z]+)([A-Z][a-z0-9])/g, '$1_$2')
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
        .toLowerCase();
}

export async function loadTrainingSnapshot(url) {
    const response = await fetch(url, { cache: "no-store" });
    if (!response.ok) {
        throw new Error(`Failed to load snapshot (${response.status})`);
    }
    return response.json();
}

export function applyTrainingSnapshot(dashboard, snapshot) {
    if (!snapshot || !snapshot.data) return 0;
    const entries = Object.values(snapshot.data);
    let count = 0;
    const repeatTargets = new Set(["shaper_live_throughput", "circuit_live"]);

    const dispatchItem = (item, repeats = 1) => {
        if (!item || !item.target) return;
        const normalized = normalizeTargetName(item.target);
        const msg = { Data: { ...item, target: normalized } };
        for (let i = 0; i < repeats; i++) {
            dashboard.dispatchMessage(msg);
            count += 1;
        }
    };

    entries.forEach((entry) => {
        if (!entry) return;
        if (Array.isArray(entry)) {
            if (entry.length === 1 && entry[0]?.target && repeatTargets.has(entry[0].target)) {
                dispatchItem(entry[0], 2);
            } else {
                entry.forEach((item) => dispatchItem(item, 1));
            }
            return;
        }
        const repeats = entry.target && repeatTargets.has(entry.target) ? 2 : 1;
        dispatchItem(entry, repeats);
    });
    return count;
}
